import React from 'react';
import { IContextualMenuProps, CommandBarButton, initializeIcons } from '@fluentui/react';
import styles from './LanguageSwitch.module.css';

initializeIcons();

type LanguageSwitchProps = {
    language: string;
    onLanguageSwitch: (language: string) => void;
};

const LanguageSwitch: React.FC<LanguageSwitchProps> = (props) => {
    const { language, onLanguageSwitch } = props;
    const lang = language === 'en' ? 'English' : 'Czech';

    const menuProps: IContextualMenuProps = {
        items: [
            {
                key: 'en',
                text: 'English',
                onClick: () => onLanguageSwitch('en'),
            },
            {
                key: 'cs',
                text: 'Czech',
                onClick: () => onLanguageSwitch('cs'),
            },
        ],
        isBeakVisible: false
    };

    return (
        <div className={styles.languageSwitch}>
            <CommandBarButton
                iconProps={{ iconName: 'World' }}
                text={lang}
                menuProps={menuProps}
                className={styles.btn}
            />
        </div>
    );
};

export default LanguageSwitch;
